<div class="system-down-content" [ngClass]="{ 'dark-theme': isDarkTheme }">
    <div class="title">
      <img [src]="pauseIconMini" alt="Exclamation" class="exclaim-icon">
      Temporarily Paused
    </div>
  
    <div class="system-down-text">
      System is preparing for the next check-in window
    </div>
  
    <img [src]="pauseIcon" alt="System Down" class="system-down-icon">
  
    <div class="suggestion-text">
      Fresh check-ins will be available at <strong>12.00 PM IST</strong>
    </div>
  </div>